import request from '@/utils/request'

//从环境变量获取auth服务的路径
const VUE_APP_AUTH_PATH = process.env.VUE_APP_AUTH_PATH
//从环境变量获取systemh服务的路径
const VUE_APP_ROLE_PATH = process.env.VUE_APP_ROLE_PATH
//获取存储在localstorage中token对应的key名
const VUE_APP_LOCALSTORAGE_TOKEN_NAME = process.env.VUE_APP_LOCALSTORAGE_TOKEN_NAME
// const VUE_APP_LOCALSTORAGE_CLIENT_ID = process.env.VUE_APP_LOCALSTORAGE_CLIENT_ID
const VUE_APP_LOCALSTORAGE_TENANTID = process.env.VUE_APP_LOCALSTORAGE_TENANTID
// pc端固定客户端授权id
const clientId = process.env.VUE_APP_CLIENT_ID;
//初始化token.从浏览器localstroage中获取
// const cachedClientId = localStorage.getItem(VUE_APP_LOCALSTORAGE_CLIENT_ID)
//初始化token.从浏览器localstroage中获取
// const cachedToken = localStorage.getItem(VUE_APP_LOCALSTORAGE_TOKEN_NAME)

//初始化state
const state = {
    // clientId:cachedClientId,
    token:null,
    isencrypt: true,
    tenantId:"",
    roles:[],
    permissions:null,
    user:null
}

  //定义getter
  const getters = {
    getRoles:(state)=>{
      return state.roles;
    }
  }

  //定义同步的操作，即mutation
const mutations = {
//   setClientId(state, clientId) {
//     // 如果token 为null，从local中移除
//     if (clientId) {
//       localStorage.setItem(VUE_APP_LOCALSTORAGE_CLIENT_ID, clientId)
//     }
//     //否则写入local
//     else {
//       localStorage.removeItem(VUE_APP_LOCALSTORAGE_CLIENT_ID)
//     }
//     //更改state状态
//     state.clientId = clientId
//   },
  setToken(state, token) {
    // 如果token 为null，从local中移除
    if (token) {
      localStorage.setItem(VUE_APP_LOCALSTORAGE_TOKEN_NAME, token);
    }
    //否则写入local
    else {
      localStorage.removeItem(VUE_APP_LOCALSTORAGE_TOKEN_NAME, token);
    }
    //更改state状态
    state.token = token
  },
  setUser(state, user){
    state.user = user;
  },
  setTenantId(state, tenantId){
    if (tenantId) {
      localStorage.setItem(VUE_APP_LOCALSTORAGE_TENANTID, tenantId);
    }
    //否则写入local
    else {
      localStorage.removeItem(VUE_APP_LOCALSTORAGE_TENANTID, tenantId);
    }
    state.tenantId = tenantId;
  },
  setRoles(state, roles){
    state.roles = roles;
  },
  setPermissions(state, permissions){
    state.permissions = permissions;
  },
}

//定义异步的操作，即action
const actions = {
    /**
     * @description 登录
     * @param {*} data
     * @return {Promise}
     */
    // eslint-disable-next-line no-unused-vars
    async login({ commit }, data) {
        const params = {
          ...data,
          clientId: data.clientId || clientId,
          grantType: data.grantType || 'password'
        };
        const url = `${VUE_APP_AUTH_PATH}/login/for-enterprise`
        const result = await request.post(url,params,{
          headers: {
              isToken: false,
              isEncrypt: true,
              repeatSubmit: false
          }
        });

        //获取服务返回数据
        const res = result.data;
        commit('setToken', res.access_token);
        return result;
    },
    async logout({commit, dispatch}){
      const url = `${VUE_APP_AUTH_PATH}/logout`;
      const result = await request.post(url);
      commit('setToken', "");
      commit('setRoles', []);//清除角色，否则重新登陆时获取到的路由不是最新的
      commit('setPermissions',null);//清除权限
      commit("setTenantId","");
      dispatch('app/setTabsListInfo', [], { root: true });//清除tabs标签页
      return result;
    },
    async getCodeImg(){
      const result = await request.get(`${VUE_APP_AUTH_PATH}/code`,{
          headers: {
            isToken: false
          },
          timeout: 20000
      })
      return result;
    },
    // 获取用户详细信息
    async getInfo({ commit }){
      const url = `${VUE_APP_ROLE_PATH}/user/getInfo`
      const result = await request.get(url);
      if(result?.data?.user){
         commit("setUser",result.data.user);
      }
      if(result?.data?.user?.tenantId){
        commit("setTenantId",result.data.user.tenantId);
      }
      if(result?.data?.roles){
        commit("setRoles",result.data.roles);
      }
      if(result?.data?.permissions){
        commit("setPermissions",result.data.permissions);
      }
      return result;
    },
    // 根据code登录
    async loginByCode({ commit },params){
      const url = `${VUE_APP_AUTH_PATH}/opt-to-ent/code-login`
      const result = await request.get(url,{params});
      if(result?.data?.access_token){
        commit("setToken",result.data.access_token);
      }
      return result;
    }
  }

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }
